import { render } from "./PageForm.vue?vue&type=template&id=1b580973&scoped=true"
import script from "./PageForm.vue?vue&type=script&lang=js"
export * from "./PageForm.vue?vue&type=script&lang=js"

import "./PageForm.vue?vue&type=style&index=0&id=1b580973&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b580973"]])

export default __exports__